// frontend/src/utils/assetFormPayload.js
/**
 * Shared payload builders for Asset create/update.
 * Keeps AddAssetModal and EditAssetModal in sync with AssetCreateUpdateSerializer.
 */

/**
 * Build optional asset fields (serial_number, brand, model, purchase, warranty, etc.).
 * Used by both create and update.
 */
export const buildAssetOptionalPayload = (form) => {
  const data = {};
  if (form.serial_number !== undefined) data.serial_number = form.serial_number;
  if (form.brand !== undefined) data.brand = form.brand;
  if (form.model !== undefined) data.model = form.model;
  if (form.description !== undefined) data.description = form.description;
  if (form.condition !== undefined) data.condition = form.condition;
  if (form.location !== undefined) data.location = form.location;
  if (form.remarks !== undefined) data.remarks = form.remarks;

  const pd = form.purchase_date;
  data.purchase_date = pd === '' || pd == null ? null : pd;

  const pp = form.purchase_price;
  data.purchase_price = pp === '' || pp == null ? null : (isNaN(Number(pp)) ? null : Number(pp));

  if (form.vendor !== undefined) {
    const vid = form.vendor;
    data.vendor = vid === '' || vid == null ? null : Number(vid);
  }
  if (form.purchase_vendor !== undefined) data.purchase_vendor = form.purchase_vendor;
  if (form.purchase_order_number !== undefined) data.purchase_order_number = form.purchase_order_number;
  if (form.invoice_number !== undefined) data.invoice_number = form.invoice_number;
  if (form.ownership_type !== undefined) data.ownership_type = form.ownership_type;

  const ws = form.warranty_start_date;
  data.warranty_start_date = ws === '' || ws == null ? null : ws;
  const we = form.warranty_end_date;
  data.warranty_end_date = we === '' || we == null ? null : we;

  if (form.warranty_provider !== undefined) data.warranty_provider = form.warranty_provider;
  if (form.warranty_terms !== undefined) data.warranty_terms = form.warranty_terms;

  if (form.custom_fields !== undefined && typeof form.custom_fields === 'object') {
    const cleaned = {};
    for (const [k, v] of Object.entries(form.custom_fields)) {
      if (v === '' || v == null) continue;
      const num = Number(v);
      cleaned[k] = !isNaN(num) && typeof v === 'string' && v.trim() !== '' && /^-?\d+(\.\d+)?$/.test(v.trim())
        ? num
        : v;
    }
    data.custom_fields = Object.keys(cleaned).length > 0 ? cleaned : {};
  }

  return data;
};

/**
 * Payload for PATCH /asset-inventory/assets/{id}/
 */
export const buildUpdatePayload = (form) => {
  const data = buildAssetOptionalPayload(form);
  if (form.asset_tag !== undefined) data.asset_tag = (form.asset_tag || '').trim();
  return data;
};

/**
 * Payload for POST /asset-inventory/assets/
 * Required: asset_type (id), asset_tag.
 */
export const buildCreatePayload = (form) => {
  const data = {
    asset_type: parseInt(form.asset_type, 10),
    asset_tag: (form.asset_tag || '').trim(),
    ...buildAssetOptionalPayload(form),
  };
  return data;
};
